import * as yup from 'yup';
import { cancelReasonField } from '../../../../ui-toolkit/orders/components/CancelOrder/cancelOrderSchema';
import { eCancellationRequestStatus } from '../../../../ui-toolkit/orders/interfaces/eCancellationRequestStatus';

export const updateOrderCancellationRequestSchema = yup.object().shape({
  type: yup.mixed<eCancellationRequestStatus>().required(),
  confirm: cancelReasonField,
  reject: cancelReasonField.when('type', {
    is: eCancellationRequestStatus.Declined,
    then: cancelReasonField.required(),
  }),
});
